
const AWS = require("aws-sdk");
const { API } = require("aws-amplify");

class ChimeUtil {
  constructor(){
    
    this.meeting = null
    this.attendee = null
  }
  /**
   * Chime SDKからミーティングIDを取得する
   */
  async createMeetingId() {
    try {
      // console.log(`Start createMeetingId:`);

      const meetingApiName = 'mczv1restapi'
      let meetingApiPath = '/meetingInfo'      
      
      const params = {
        headers: {},
        response: true,
      };
      const result = await API.get(meetingApiName, meetingApiPath, params)
      
      this.meeting = result.data.meeting;

      // console.log(`MeetingId:${this.meeting.MeetingId}`);

      if (!this.meeting) {
        throw new Error(`Meeting is empty.`);
      }

      return this.meeting
    } catch (e) {
      console.log(`ChimeConnection.createMeeting:${JSON.stringify(e)}`);
      throw e;
    }
  }
  async getMeetingPost(pk, sk) {
    try {
      const meetingApiName = 'mczv1restapi'
      let meetingApiPath = '/meeting'

      const params = {
        headers: {},
        response: true,
        body: {
          pk: pk,
          sk: sk
        }
      };
      
      const result = await API.post(meetingApiName, meetingApiPath, params)
      if (!result.data) {
        throw new Error(`Meeting is empty.`);
      }
      if (!result.data.meeting) {
        throw new Error(`Meeting is empty.`);
      }
      return result.data.meeting
    } catch (e) {
      console.log(`ChimeConnection.getMeeting:${JSON.stringify(e)}`);
      throw e;
    }
  }
  /**
   * Chime SDKから既存のミーティングIDを取得する
   */
  async getMeeting(meetingId) {
    try {
      // console.log(`Start getMeeting:`);

      const meetingApiName = 'mczv1restapi'
      let meetingApiPath = '/meeting'
      meetingApiPath = `${meetingApiPath}/${meetingId}`
      
      const params = {
        headers: {},
        response: true,
      };
      const result = await API.get(meetingApiName, meetingApiPath, params)
      // console.log(`result:${JSON.stringify(result, null, "\t")}`)
      
      if (!result.data) {
        throw new Error(`Meeting is empty.`);
      }
      if (!result.data.meeting) {
        throw new Error(`Meeting is empty.`);
      }
      return result.data.meeting
    } catch (e) {
      console.log(`ChimeConnection.getMeeting:${JSON.stringify(e)}`);
      throw e;
    }
  }
  /**
   * 指定したミーティングIDに参加者を追加する
   * @param {*} meetingId 
   * @param {*} userName 
   */
  async createAttendee(meetingId, userName = "") {
    try {
      // console.log(`Start createAttendee:${meetingId}`);
      
      const attendeeApiName = 'mczv1restapi'
      let attendeeApiPath = '/attendee'
      attendeeApiPath = `${attendeeApiPath}/${encodeURIComponent(meetingId + "#" + userName)}`
      const params = {
        headers: {},
        response: true,
      };
      const result = await API.get(attendeeApiName, attendeeApiPath, params)
      if (result.data) {
        this.attendee = result.data.attendee
      }
      
      if (!this.attendee) {
        throw new Error(`Attendee is empty.`);
      }
      return this.attendee
    } catch (e) {
      console.log(`ChimeConnection.createAttendee:${JSON.stringify(e)}`);
      throw e;
    }
  }
}
module.exports = ChimeUtil